// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2ee2b994","703":"2ff23a28"}[chunkId] + ".chunk.js";
};